import { useIndexPrice } from './indexprice'

export function useLastPrice(symbol: string) {
	const { data, mutate } = useIndexPrice(symbol)
	return {
		data: data,
		mutate: mutate,
	}
}
